import { modifiedSetTimeout } from '../utilities/ZoneUtils';
import {
  DEFAULT_HEIC_CONVERSION_POLL_INTERVAL_MS,
  DEFAULT_HEIC_CONVERSION_RELOAD_ATTEMPTS,
} from './image-conversion.service';

/**
 * Poll a URL with `HEAD` until it returns ok or attempts are exhausted.
 */
export async function pollHeadUntilUrlOk(
  url: string,
  maxAttempts: number,
  intervalMs: number,
): Promise<boolean> {
  const delay =
    Number.isFinite(intervalMs) && intervalMs >= 0
      ? intervalMs
      : DEFAULT_HEIC_CONVERSION_POLL_INTERVAL_MS;
  const validatedMaxAttempts =
    Number.isFinite(maxAttempts) && maxAttempts >= 0
      ? maxAttempts
      : DEFAULT_HEIC_CONVERSION_RELOAD_ATTEMPTS;
  for (let attempt = 0; attempt < validatedMaxAttempts; attempt++) {
    try {
      const response = await fetch(url, { method: 'HEAD' });
      if (response.ok) {
        return true;
      }
    } catch {
      // Object not ready yet, continue polling
    }

    if (attempt < validatedMaxAttempts - 1) {
      await new Promise((resolve) => modifiedSetTimeout(resolve, delay, true));
    }
  }

  return false;
}
